import * as angular from 'angular';

import {
  Input,
  OnInit,
  Inject,
  Component,
} from 'ng-metadata/core';

import { CartService } from 'services/cart.service';
import { EtomsService } from 'services/etoms.service';

import cartSummaryHtml from './cart-summary.html';
import './cart-summary.scss';
import { runInThisContext } from 'vm';



/**
 * Shopping Cart Summary for checkout sidebar
 */
@Component({
  selector: 'gwCheckoutCartSummary',
  template: cartSummaryHtml,
})
export class CartSummaryComponent implements OnInit {
  public laroute = (<any>window).laroute;
  public etomsEnabled: Boolean = false;

  public cart;
  public state = {
    toggles: [],
  };

  @Input() collapsed: boolean;

  constructor(
    @Inject('$filter') private $filter,
    @Inject(CartService) private cartService: CartService,
    @Inject(EtomsService) private etomsService: EtomsService,
  ) {}

  ngOnInit() {
    this.cart = this.cartService.getCart();
    this.etomsEnabled = this.etomsService.enabled();
  }

  containsMailaways() {
    let contains = false;

    this.cart.order.some((orderItem) => {
      const product = this.cart.products[orderItem.productId];
      const option = this.cart.options[orderItem.optionsId];
      contains = this.cartService.determineMailaway(product, option);
      return contains;
    });

    return contains;
  }

  determineGovFee(orderItem) {
    const product = this.cart.products[orderItem.productId];
    const option = this.cart.options[orderItem.optionsId];
    const addons = orderItem.addons;

    const fee = this.cartService.determineGovFee(product, addons, option);

    return this.$filter('currency')(fee);
  }

  getInboundShippingTotal() {
    let inbound = 0;

    this.cart.order.forEach((orderItem, index) => {
      if (orderItem.requireShipping && (inbound === 0 || orderItem.type !== 'visa')) {
        const option = this.cart.options[orderItem.optionsId];
        inbound += option ? option.inboundShipping : 0;
        if (this.etomsEnabled) {
          return inbound;
        }
      }
    });

    return inbound;
  }

  getOutboundShippingTotal() {
    let outbound = 0;

    this.cart.order.forEach((orderItem, index) => {
      if (orderItem.requireShipping && (outbound === 0 || orderItem.type !== 'visa')) {
        outbound += orderItem.outbound ? orderItem.outbound.price : 0;
        if (!this.etomsEnabled) {
          return outbound;
        }
      }
    });

    return outbound;
  }

  getShippingTotal() {
    let total = 0;

    this.cart.order.forEach((orderItem, index) => {
      if (orderItem.requireShipping && (total === 0 || orderItem.type !== 'visa')) {
        total += this.cartService.getShippingTotal(orderItem);
        if (this.etomsEnabled) {
          return this.$filter('currency')(total);
        }
      }
    });

    return this.$filter('currency')(total);
  }

  subtotal(orderItem): string {
    const subtotal = this.cartService.getSubtotalNew(orderItem);
    return this.$filter('currency')(subtotal);
  }

  total(): string {
    const total = this.cartService.getOrderTotal();
    return this.$filter('currency')(total);
  }

  /**
   * Return the travel name
   * @param travelerId
   */
  getTravelerName(travelerId) {
    if (this.cart.travelers[travelerId].name !== null) {
      return this.cart.travelers[travelerId].name;
    }

    const pos = Object.keys(this.cart.travelers).indexOf(travelerId) + 1;
    return `Traveler ${pos}`;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/cart-summary/cart-summary.component.ts